import { useStore } from "vuex";
import { computed } from "vue";

export default function useQrButton() {
  const store = useStore();

  const showQrButton = computed(() => {
    const isCMS = store.getters.showCMS;
    const isTouchScreen = store.getters.getTouchScreen;
    const show = store.getters.getStoreVar(
      "Categories",
      "styling",
      "pageSettingsToggle",
      "showFooterQR"
    );
    return show && (isTouchScreen || isCMS);
  });

  return { showQrButton };
}
